module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "track-by": "name",
      "options": _vm.Storage.webNewFilter,
      "multiple": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": _vm.$t('statistic.webmaster'),
      "label": "name",
      "searchable": true,
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n           " + _vm._s(props.option.name) + "\n          ")])])]
      }
    }]),
    model: {
      value: (_vm.Storage.webNewSelectedFilter),
      callback: function($$v) {
        _vm.Storage.webNewSelectedFilter = $$v
      },
      expression: "Storage.webNewSelectedFilter"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15edfdd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/NewWmFilter.vue
// module id = 518
// module chunks = 0